// © Microsoft Corporation. All rights reserved.

import { ElementStyles, css } from "@microsoft/fast-element";
import { elevation, heightNumber, neutralForegroundHintBehavior, neutralForegroundRestBehavior, neutralLayerFloatingBehavior, neutralOutlineRestBehavior } from "@fluentui/web-components";

import { ZIndex } from "@msnews/core";

const dialogZIndex = `${ZIndex.Dialog}`;

export const SettingsStyles: ElementStyles = css`
.settings-button {
    align-items: center;
    display: flex;
    height: calc(${heightNumber} * 1px);
    justify-content: center;
    width: calc(${heightNumber} * 1px);
}

.settings-button::part(control) {
    height: calc(${heightNumber} * 1px);
    width: calc(${heightNumber} * 1px);
}

.settings-button::part(control):hover {
    fill: var(--hover-color);
}

.settings-button::part(control):active {
    fill: var(--active-color);
}

.settings-button::part(content) {
    line-height: 0;
}

.settings-close-button {
    height: calc(${heightNumber} * 1px);
    width: calc(${heightNumber} * 1px);
    background: ${neutralLayerFloatingBehavior.var};
}

.settings-close-button svg {
    height: 12px;
    width: 12px;
    fill: ${neutralForegroundRestBehavior.var};
}

.settings-dialog {
    --dialog-width: 320px;
    --dialog-height: fit-content;
}

.settings-dialog::part(overlay) {
    background: none;
}

.settings-dialog::part(control) {
    --elevation: 11;
    ${elevation}
    background: ${neutralLayerFloatingBehavior.var};
    border: calc(var(--outline-width) * 1px) solid transparent;
    border-radius: var(--elevated-corner-radius);
    display: flex;
    flex-direction: column;
    z-index: ${dialogZIndex};
    margin: 0;
}

.settings-dialog-header {
    display: flex;
    flex-direction: row;
}

.settings-dialog-title {
    margin: 12px auto 8px;
    margin-inline-start: 16px;
    font-size: var(--type-ramp-plus-1-font-size);
    line-height: var(--type-ramp-plus-1-line-height);
    font-weight: 600;
}

.language-dropdown {
    margin: 8px 16px;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
}

msn-market-selector::part(select) {
    margin-top: 12px;
    margin-bottom: 0;
}

.personalize-settings {
    display: flex;
    flex-direction: row;
    margin: 8px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
}

.personalize-settings-button {
    border: 1px solid ${neutralOutlineRestBehavior.var};
    border-radius: 2px;
    padding: 0;
    margin: 0 0 0 15px;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
    box-sizing: border-box; 
    cursor: pointer;
    color: ${neutralForegroundRestBehavior.var};
    fill: ${neutralForegroundRestBehavior.var};
    height: fit-content;
}

.personalize-settings-button::part(content) {
    max-width: 115px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.personalize-settings-button::part(control) {
    width: 100%;
    white-space: normal;
    padding: 6px 12px;
}

.footer {
    display: flex;
    flex-direction: column;
    margin: 8px 16px;
    color: ${neutralForegroundHintBehavior.var};
    font-size: var(--type-ramp-minus-2-font-size);
    line-height: var(--type-ramp-base-line-height);
}

.footer-links a {
    color: ${neutralForegroundHintBehavior.var};
    text-decoration: none;
}
`.withBehaviors(
        neutralOutlineRestBehavior,
        neutralForegroundHintBehavior,
        neutralForegroundRestBehavior,
        neutralLayerFloatingBehavior
    );
